module.exports = __webpack_public_path__ + "img/item-04.152cb67f.jpg";